import { type PrimaryCategoryEntityReassignmentPreviewConstructor } from '@webapp/platform/organization-management/entities/PrimaryCategoryEntityReassignmentPreview'
import { type PrimaryCategoryEntityReassignmentPreviewApiModel } from '../api-models/PrimaryCategoryEntityReassignmentPreviewApiModel'

export const mapPrimaryCategoryEntityReassignmentPreviewApiModel = (
  apiModel: PrimaryCategoryEntityReassignmentPreviewApiModel
): PrimaryCategoryEntityReassignmentPreviewConstructor => ({
  missingAccessCount: apiModel.missing_access_count,
  users: apiModel.users.map((user) => ({
    userId: user.user_id,
    firstName: user.first_name,
    lastName: user.last_name,
    email: user.email,
  })),
})
